/**
 * @file Home Page
 * @author zhenglujie(zhenglujie@baidu.com))
 * Copyright (c) 2019-06-04 Baidu
 */

import React from 'react';
import {connect} from 'react-redux';
import './index.less';
import {Carousel, Button} from 'antd';
import {Link} from 'react-router-dom';
import {setCurrentPage} from '../../actions/generalAction';
import banner from '../../img/banner.png';
import advantageQuality from '../../img/advantage-quality.svg';
import advantageApi from '../../img/advantage-api.svg';
import advantageAnalysis from '../../img/advantage-analysis.svg';
import advantageSecurity from '../../img/advantage-security.svg';
import senerioSmsTip from '../../img/senerio-sms-tip.png';
import senerioAppTip from '../../img/senerio-app-tip.png';
import senerioQrcodeTip from '../../img/senerio-Qrcode-tip.png';
import senerioChannelTip from '../../img/senerio-channel-tip.png';
import senerioSmsDemo from '../../img/senerio-sms-demo.png';
import senerioAppShare from '../../img/senerio-app-share.png';
import applicationQRcode from '../../img/application-QRcode.png';
import senerioChannelAnalysis from '../../img/senerio-channel-analysis.png';
import reportDemo from '../../img/report-demo.png';
import reportZeroCost from '../../img/report-zero-cost.png';
import reportSmartFilter from '../../img/report-smart-filter.png';
import reportAuthoritativeAnalysis from '../../img/report-authoritative-analysis.png';
import partnerCMB from '../../img/partner-CMB.png';
import partnerCUA from '../../img/partner-CUA.png';
import partnerSAIC from '../../img/partner-SAIC.png';
import partnerKUAI from '../../img/partner-KUAI.png';
import partnerLIETOU from '../../img/partner-LIETOU.png';
import partnerSeabed from '../../img/partner-Seabed.png';
import logoBFE from '../../img/logo-bfe.png';
import logoHTTPDNS from '../../img/logo-httpdns.png';
import logoITM from '../../img/logo-itm.png';
import logoAIPage from '../../img/logo-aipage.png';
import logoCece from '../../img/logo-cece.png';
import bannerDwz from '../../img/banner-dwz.png';
import bannerCece from '../../img/banner-cece.png';

class Home extends React.Component {
    linkToPrice() {
        this.props.dispatch(setCurrentPage('price'));
        document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
    linkToProduct() {
        this.props.dispatch(setCurrentPage('product'));
        document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
    linkToApi() {
        this.props.dispatch(setCurrentPage('apidoc'));
        document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
    // linkToAdv() {
    //     this.props.dispatch(setCurrentPage('senior'));
    //     document.documentElement.scrollTop = document.body.scrollTop = 0;
    // }
    linkToOperation() {
        /* eslint-disable */
        _hmt.push(['_trackEvent', '首页轮播', 'banner_click_operation', '点击体验短网址']);
        // this.props.dispatch(setCurrentPage('operation'));
        window.open('//cloud.baidu.com/product/dwz.html', '_blank');
        // document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
    linkToDwz(){
        /* eslint-disable */
        _hmt.push(['_trackEvent', '首页轮播', 'banner_click_dwz', '点击跳转短网址控制台']);
    }
    // moreLinkToSpp(){
    //     /* eslint-disable */
    //     _hmt.push(['_trackEvent', '首页了解更多', 'more_click_spp', '了解更多跳转移动推送']);
    // }
    jumpBFE() {
        window.open('https://www.bfe-networks.net/', '_blank');
    }
    jumpCece() {
        /* eslint-disable */
        _hmt.push(['_trackEvent', '首页更多产品', 'more_click_cece', '更多产品跳转百度测测']);
        window.open('https://cece.baidu.com/home', '_blank');
    }
    jumpDNS() {
        window.open('https://cloud.baidu.com/product/httpdns.html', '_blank');
    }
    jumpITM() {
        window.open('https://cloud.baidu.com/product/itm.html', '_blank');
    }
    jumpAIPage() {
        window.open('https://aipage.baidu.com', '_blank');
    }
    render() {
        const settings = {
            autoplay: true,
            autoplaySpeed: 4000,
        };
        const ImportantNoticeOne = '亲爱的短网址用户：';
        // const ImportantNoticeTwo = '为满足国家相关监管部门关于链接跳转内容的监管要求，打击通过短网址服务进行涉嫌诈骗、'
        //     + '涉黄涉暴的非法行为，短网址服务将开展对正在使用的匿名短网址的审查及下线、对短网址服务中违规短链进行清理。'
        //     + '请各位用户遵守相关规定，共同维护良好的网络环境。';
        const ImportantNoticeThree = '如果您正在使用的短网址是8位以下并未登记过企业信息，请您自行备份重要数据。'
            + '需要继续使用短网址服务，请您通过百度智能云';
        // const ImportantNoticeFour = '• 如果您是以个人名义注册账号的企业，可进行';
        // const ImportantNoticeFive = '• 已创建的短网址目前仍可正常跳转。';
        // const ImportantNoticeSix = '• 如果您不再继续使用短网址，可在';
        // const ImportantNoticeSeven = '• 企业用户： ';
        // const ImportantNoticeEight = '• 短网址将加强内容审核，因此可能造成创建短网址失败。可';
        // const ImportantNoticeNine = '感谢各位用户与我们共同建设更好的互联网环境，由此带来的不便敬请谅解！';
        // const ImportantNoticeTen = '如有任何疑问，可联系我们';
        return (
            <div className="new-container">
                {/* 首页轮播图布局开始 */}
                <div className="dwz-banner" >
                    <div>
                        <img src={banner} />
                        <div className='banner-msg'>
                            <Carousel {...settings}>
                                <div className='bannerpage'>
                                    <div className='bannerpage-msg'>
                                        <p>百度短网址</p>
                                        <p className='bannerpage-msg-dec'>专业的网址缩短和营销数据分析平台</p>
                                        <div>
                                            <p>质优价低</p>
                                            <p>短信营销好搭档</p>
                                            <p>低成本获取专业数据分析</p>
                                        </div>
                                        <Button
                                            className="operation-btn"
                                            type="primary">
                                            <Link to='' onClick={() => this.linkToOperation()}>立即体验&gt;
                                        </Link>
                                        </Button>
                                    </div>
                                    <div className='bannerpage-img'>
                                        <img src={bannerDwz} />
                                    </div>
                                </div>
                                <div className='bannerpage'>
                                    <div className='bannerpage-msg'>
                                        <p>短网址服务</p>
                                        <p className='bannerpage-msg-dec'>新功能发布！提供直接二维码转换、应用通过短链调起功能</p>
                                        <div>
                                            <p>短网址生成可直接下载二维码</p>
                                            <p>年包用户可申请短链唤起应用服务</p>
                                        </div>
                                        <Button
                                            onClick={() => {this.linkToDwz();}}
                                            className="operation-btn"
                                            type="primary">
                                            <a href="https://console.bce.baidu.com/dwz/?channel=portal" target="_blank">
                                            马上咨询</a>
                                        </Button>
                                        <div>
                                            <p>申请可发送邮件至ext_dwz-help@baidu.com</p>
                                        </div>
                                    </div>
                                    <div className='bannerpage-img'>
                                        <img src={bannerCece} />
                                    </div>
                                </div>
                            </Carousel>
                        </div>
                    </div>
                </div>
                {/* 首页轮播图布局结束 */}
                {/* 了解更多布局开始 */}
                <div className='more'>
                    <div className='content'>
                        <span>了解更多:</span>
                        <ul>
                            <li><Link to="/console/price" onClick={() => this.linkToPrice()}>产品价格</Link></li>
                            <li><Link to="/console/product" onClick={() => this.linkToProduct()}>产品服务</Link></li>
                            {/* <li><Link to="/console/advanced_report" onClick={() => this.linkToAdv()}>数据分析指南</Link></li> */}
                            <li><Link to="/console/apidoc" onClick={() => this.linkToApi()}>接口文档</Link></li>
                            {/* <li><a href="https://growing.baidu.com/spp.html" target="_blank" onClick={() => this.moreLinkToSpp()}>移动推送</a></li> */}
                        </ul>
                    </div>
                </div>
                {/* 了解更多布局结束 */}
                {/* 重要通知布局开始 */}
                <div className="ImportantNotice">
                    <p className="title">重要通知</p>
                    <div style={{margin: '30px 0'}} >
                        <p style={{textIndent: '2em'}}>{ImportantNoticeOne}</p>
                        <p style={{textIndent: '2em'}}>
                            <span>为满足国家相关监管部门关于链接跳转内容的监管要求，打击通过短网址服务进行涉嫌诈骗、</span>
                            <span>涉黄涉暴的非法行为，短网址服务将开展<strong>对正在使用的匿名短网址的审查及下线、对短网址服务中违规短链进行清理。</strong></span>
                            <span>请各位用户遵守相关规定，共同维护良好的网络环境。</span>
                        </p>
                        <p style={{textIndent: '2em'}}>{ImportantNoticeThree}
                            <a href="https://cloud.baidu.com/doc/UserGuide/s/ejwvy3fo2" target="_blank">注册账号</a>
                            进行<a href="https://cloud.baidu.com/doc/UserGuide/s/3kuwcaomi" target="_blank">企业实名认证</a>
                            后，进入短网址服务控制台使用。其他问题，您也可以直接
                            <Button className="consultation" type="primary">
                                <a href="https://ticket.bce.baidu.com/#/ticket/create~productId=188&questionId=706&channel=2" target="_blank">联系我们</a>
                            </Button>
                        </p>
                        <p style={{textIndent: '2em'}}>
                            使用前，请一定查阅常见问题<a href="https://dwz.cn/console/faq" target="_blank">https://dwz.cn/console/faq</a>
                        </p>
                        <p style={{textIndent: '2em'}}>感谢您的配合与理解。</p>
                        {/* <p style={{textIndent: '4.5em'}}>{ImportantNoticeFour}
                            <a href="https://cloud.baidu.com/doc/UserGuide/s/Ajwvy3ckg" target="_blank">企业账号认证</a>。</p>
                        <p style={{textIndent: '4.5em'}}>{ImportantNoticeFive}</p>
                        <p style={{textIndent: '4.5em'}}>
                            {ImportantNoticeSix}
                            <a href="https://ticket.bce.baidu.com/?_=1587443699892&_/#/ticket/create~productId=64&questionId=399&channel=2" target="_blank">工单</a>
                            内申请退款。
                        </p>
                        <p style={{textIndent: '2em'}}>{ImportantNoticeSeven}</p>
                        <p style={{textIndent: '4.5em'}}>
                            {ImportantNoticeEight}
                            <a href="https://ticket.bce.baidu.com/#/ticket/create~productId=188&questionId=898" target="_blank">联系我们</a>
                            进行安全审核，通过审核后，即可创建短网址。
                        </p>
                        <p>{ImportantNoticeNine}</p> */}
                        {/* <p>
                            {ImportantNoticeTen}
                            <Button className="consultation" type="primary">
                                <a href="https://ticket.bce.baidu.com/#/ticket/create~productId=188&questionId=706&channel=2" target="_blank">客服咨询</a>
                            </Button>
                        </p> */}
                    </div>
                </div>
                {/* 重要通知布局结束 */}
                {/* 百度多年技术积累和优势布局开始 */}
                <div className='advantage'>
                    <div className='content'>
                        <p className='title'>百度多年技术积累和优势</p>
                        <div className='advantage-box'>
                            <div className='advantage-msg'>
                                <div className='advantage-img'>
                                    <img src={advantageQuality} />
                                </div>
                                <div className='advantage-des'>
                                    <div className='advantage-des-title'>
                                        质优价低
                                    </div>
                                    <div className='advantage-des-msg'>
                                        <ul>
                                            <li>高性价比，省钱又省心</li>
                                            <li>计费灵活，多种可选套餐</li>
                                            <li>智能过滤虚假流量，节约成本</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='advantage-msg'>
                                <div className='advantage-img'>
                                    <img src={advantageApi} />
                                </div>
                                <div className='advantage-des'>
                                    <div className='advantage-des-title'>
                                        API简单易用
                                    </div>
                                    <div className='advantage-des-msg'>
                                        <ul>
                                            <li>稳定高并发</li>
                                            <li>二次开发接入简便</li>
                                            <li>提供多语言示例代码</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='advantage-msg'>
                                <div className='advantage-img'>
                                    <img src={advantageAnalysis} />
                                </div>
                                <div className='advantage-des'>
                                    <div className='advantage-des-title'>
                                        专业数据分析
                                    </div>
                                    <div className='advantage-des-msg'>
                                        <ul>
                                            <li>低成本接入，无需埋点</li>
                                            <li>高级报表-全面展示网址点击数据</li>
                                            <li>分析云-精准锁定目标人群</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='advantage-msg'>
                                <div className='advantage-img'>
                                    <img src={advantageSecurity} />
                                </div>
                                <div className='advantage-des'>
                                    <div className='advantage-des-title'>
                                        安全高可用
                                    </div>
                                    <div className='advantage-des-msg'>
                                        <ul>
                                            <li>稳定性（SLA）99.9%</li>
                                            <li>防劫持，无恶意广告</li>
                                            <li>1V1专业技术支持</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* 百度多年技术积累和优势布局结束 */}
                {/* 满足多种应用场景布局开始 */}
                <div className='application'>
                    <div className='content'>
                        <p className='title'>满足多种应用场景</p>
                        <p className='title-des'>通过百度大数据多年的积累，提供专业、全面的数据分析，帮助您更了解您的用户，挖掘潜在用户，提高转化。</p>
                        <div className='application-msg'>
                            <div className='application-img'>
                                <img src={senerioSmsTip} style={{width: '100%'}} />
                            </div>
                            <div className='application-msg-des'>
                                <div className='application-msg-des-top'>
                                    <p className='application-des-title'>短信营销</p>
                                    <p className='application-des-title-des'>营销短信结合个性化短网址，根据短网址点击情况提高转化率。</p>
                                </div>
                                <div className='application-msg-des-bottom'>
                                    <div className='application-des-img'>
                                        <img src={senerioSmsDemo} style={{height: '90%'}} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='application-msg'>
                            <div className='application-img'>
                                <img src={senerioAppTip} style={{width: '100%'}} />
                            </div>
                            <div className='application-msg-des'>
                                <div className='application-msg-des-top'>
                                    <p className='application-des-title'>APP分享</p>
                                    <p className='application-des-title-des'>
                                        电商、社交、工具等各类app进行社会化分享时可使用短网址接口，缩短链接便于分享传播。
                                    </p>
                                </div>
                                <div className='application-msg-des-bottom'>
                                    <div className='application-des-img'>
                                        <img src={senerioAppShare} style={{height: '90%'}} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='application-msg'>
                            <div className='application-img'>
                                <img src={senerioQrcodeTip} style={{width: '100%'}} />
                            </div>
                            <div className='application-msg-des'>
                                <div className='application-msg-des-top'>
                                    <p className='application-des-title'>二维码简化</p>
                                    <p className='application-des-title-des'>
                                        降低二维码复杂程度，减少二维码像素，提升识别速度及成功率。
                                    </p>
                                </div>
                                <div className='application-msg-des-bottom'>
                                    <div className='application-des-img'>
                                        <img src={applicationQRcode} className='qrcode' style={{height: '80%'}} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='application-msg'>
                            <div className='application-img'>
                                <img src={senerioChannelTip} style={{width: '100%'}} />
                            </div>
                            <div className='application-msg-des'>
                                <div className='application-msg-des-top'>
                                    <p className='application-des-title'>渠道分析/AB测试</p>
                                    <p className='application-des-title-des'>
                                        营销渠道分析/AB测试分析各大渠道，协助推广决策，优化成本及效率。
                                    </p>
                                </div>
                                <div className='application-msg-des-bottom'>
                                    <div className='application-des-img'>
                                        <img src={senerioChannelAnalysis} style={{height: '90%', width: '90%'}} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* 满足多种应用场景布局结束 */}
                {/* 专业的数据统计分析报表布局开始 */}
                {/* <div className='fun'>
                    <p className='title'>专业的数据统计分析报表</p>
                    <p className='title-des'>
                        多维度统计短网址点击数据，为精细化运营决策提供数据支持，进而有效提高企业投资回报率
                    </p>
                    <div className='fun-msg'>
                        <div style={{width: '48%', display: 'flex', display: 'inline-block', flexDirection: 'column'}}>
                            <div className='fun-msg-des'>
                                <div className='function-des-msg-img'>
                                    <img src={reportZeroCost} style={{width: '80%'}} />
                                </div>
                                <div className='function-des-msg-title'>
                                    低成本接入
                                </div>
                                <div className='function-des-msg-des'>
                                    <span>
                                        低成本接入，与百度统计平台无缝对接，无需单独埋点。辅以完备的指导说明，践行简单易用的理念。
                                    </span>
                                </div>
                            </div>
                            <div className='fun-msg-des'>
                                <div className='function-des-msg-img'>
                                    <img src={reportSmartFilter} style={{width: '80%'}} />
                                </div>
                                <div className='function-des-msg-title'>
                                    智能过滤虚假流量
                                </div>
                                <div className='function-des-msg-des'>
                                    <span>
                                        智能识别技术，能有效识别流量真实性，过滤虚假流量，避免虚假流量产生不必要的费用，不仅帮助您节约成本，同时保证统计数据更精准。
                                    </span>
                                </div>
                            </div>
                            <div className='fun-msg-des'>
                                <div className='function-des-msg-img'>
                                    <img src={reportAuthoritativeAnalysis} style={{width: '80%'}} />
                                </div>
                                <div className='function-des-msg-title'>
                                    权威数据分析
                                </div>
                                <div className='function-des-msg-des'>
                                    <span>百度统计作为专业的中文网站流量分析平台，无缝结合短网址，提供权威、全面的网址点击数据。帮助您更了解用户，提高转化率。</span>
                                </div>
                            </div>
                        </div>
                        <div className='fun-img'>
                            <img src={reportDemo} style={{width: '100%'}} />
                        </div>
                    </div>
                </div> */}
                {/* 专业的数据统计分析报表布局结束 */}
                {/* 受到多种合作伙伴的信赖布局开始 */}
                <div className='trust'>
                    <p className='title'>受到多种合作伙伴的信赖</p>
                    <div className='content'>
                    <Carousel >
                        <div>
                            <div className='trust-swiper'>
                                <div style={{display: 'flex'}}>
                                    <div className='trust-swiper-img'>
                                        <img src={partnerCMB} />
                                    </div>
                                    <div className='trust-swiper-img'>
                                        <img src={partnerCUA} />
                                    </div>
                                    <div className='trust-swiper-img'>
                                        <img src={partnerSAIC} />
                                    </div>
                                </div>
                                <div style={{display: 'flex'}}>
                                    <div className='trust-swiper-img'>
                                        <img src={partnerKUAI} />
                                    </div>
                                    <div className='trust-swiper-img'>
                                        <img src={partnerLIETOU} />
                                    </div>
                                    <div className='trust-swiper-img'>
                                        <img src={partnerSeabed} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Carousel>
                    </div>
                </div>
                {/* 受到多种合作伙伴的信赖布局结束 */}
                {/* 开启您的短网址之旅布局开始 */}
                <div className='experience'>
                    <p className='title'>开启您的短网址之旅</p>
                    <div className='operation-btn'>
                        <Button
                            className="operation-btn"
                            type="primary">
                                <Link to='' onClick={() => this.linkToOperation()}>立即体验</Link>
                            </Button>
                    </div>
                </div>
                {/* 开启您的短网址之旅布局结束 */}
                {/* 更多产品布局开始 */}
                <div className='extension'>
                    <p className='title'>更多产品</p>
                    <div className='content'>
                        <div className='extension-box'>
                            <div className='extension-msg'>
                                <img src={logoCece} style={{width: '30%'}} onClick={() => { this.jumpCece(); }} />
                                <p className='jump' onClick={() => { this.jumpCece(); }}>百度测测</p>
                            </div>
                            <div className='extension-msg'>
                                <img src={logoBFE} style={{width: '30%'}} onClick={() => { this.jumpBFE(); }} />
                                <p className='jump' onClick={() => { this.jumpBFE(); }}>BFE（百度统一前端）</p>
                            </div>
                            <div className='extension-msg'>
                                <img src={logoHTTPDNS} style={{width: '30%'}} onClick={() => { this.jumpDNS(); }} />
                                <p className='jump' onClick={() => { this.jumpDNS(); }}>HTTPDNS（移动域名解析服务）</p>
                            </div>
                            <div className='extension-msg'>
                                <img src={logoITM} style={{width: '30%'}} onClick={() => { this.jumpITM(); }} />
                                <p className='jump' onClick={() => { this.jumpITM(); }}>ITM（智能流量调度）</p>
                            </div>
                            <div className='extension-msg'>
                                <img src={logoAIPage} style={{width: '30%'}}
                                onClick={() => { this.jumpAIPage(); }} />
                                <p className='jump' onClick={() => { this.jumpAIPage(); }}>AIPage（百度智能门户）</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* 更多产品布局结束 */}
            </div >
        );
    }
}
export default connect(state => ({
    currentPage: state.currentPage,
}))(Home);
